var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKreskyLogoInfoRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 9,
    viewBox: "0 0 55 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.7056 0H18.208V1.61949H25.7056V0Z",
    fill: "#FFFFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7056 3.23828H18.208V4.85777H25.7056V3.23828Z",
    fill: "#FFFFFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7056 7.01758H18.208V8.63707H25.7056V7.01758Z",
    fill: "#FFFFFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6021 2.42923C16.6021 0 13.9244 0 13.9244 0H9.10449V1.61949H13.9244C13.9244 1.61949 14.9954 1.61949 14.9954 2.42923C14.9954 3.23898 13.9244 3.23898 13.9244 3.23898H9.10449V4.85846H10.5772L14.326 8.63727H16.6021L12.8533 4.85846H13.9244C13.9244 4.85846 16.6021 4.85846 16.6021 2.42923Z",
    fill: "#FFFFFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3125 2.42923C27.3125 4.85846 29.9902 4.85846 29.9902 4.85846H32.1324C32.1324 4.85846 33.2035 4.85846 33.2035 5.93812C33.2035 7.01778 32.1324 7.01778 32.1324 7.01778H27.3125V8.63727H32.1324C32.1324 8.63727 34.8101 8.63727 34.8101 5.93812C34.8101 3.23898 32.1324 3.23898 32.1324 3.23898H29.9902C29.9902 3.23898 28.9191 3.23898 28.9191 2.42923C28.9191 1.61949 29.9902 1.61949 29.9902 1.61949H34.8101V0H29.9902C29.9902 0 27.3125 0 27.3125 2.42923Z",
    fill: "#FFFFFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.60662 0H0V2.69915H1.60662V0Z",
    fill: "#FFFFFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.75707 0L2.00828 3.7788L1.47274 4.31863H0V8.63727H1.60662V4.45359L2.00828 4.85846L5.75707 8.63727H8.03312L3.74879 4.31863L8.03312 0H5.75707Z",
    fill: "#FFFFFF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8224 5.39844H49.2158V8.63741H50.8224V5.39844Z",
    fill: "#FFFFFF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7237 0L50.4209 2.32127L51.5455 3.4819L54.9998 0H52.7237Z",
    fill: "#FFFFFF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3415 0H45.0654L48.5197 3.4819L49.6443 2.32127L47.3415 0Z",
    fill: "#FFFFFF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0236 0H36.417V2.69915H38.0236V0Z",
    fill: "#FFFFFF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1741 0L38.4253 3.7788L37.8897 4.31863H36.417V8.63727H38.0236V4.45359L38.4253 4.85846L42.1741 8.63727H44.4501L40.1658 4.31863L44.4501 0H42.1741Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKreskyLogoInfoRed);
export default __webpack_public_path__ + "static/media/kresky-logo-info-red.078ad6c4a4244e6669e9d99a71b4a49f.svg";
export { ForwardRef as ReactComponent };